import MiniAppFundQuote from '../pages/miniapp/fund/Quote.vue'
import MiniAppFundQuoteOverview from '../pages/miniapp/fund/Overview.vue'
import MiniAppFundQuotePerformance from '../pages/miniapp/fund/Performance.vue'
import MiniAppFundQuotePortfolio from '../pages/miniapp/fund/Portfolio.vue'
import MiniAppFundQuoteFees from '../pages/miniapp/fund/Fees.vue'

const routerMarket = {
    path: 'fund',
    name: 'miniapp-fund-quote',
    component: MiniAppFundQuote,
    redirect: { name: 'miniapp-fund-quote-overview' },
    props: true,
    children: [
      {
        path: 'overview',
        name: 'miniapp-fund-quote-overview',
        component: MiniAppFundQuoteOverview,
        props: true,
      },
      {
        path: 'performance',
        name: 'miniapp-fund-quote-performance',
        component: MiniAppFundQuotePerformance,
        props: true,
      },
      {
        path: 'portfolio',
        name: 'miniapp-fund-quote-portfolio',
        component: MiniAppFundQuotePortfolio,
        props: true,
      },
      {
        path: 'fees',
        name: 'miniapp-fund-quote-fees',
        component: MiniAppFundQuoteFees,
        props: true,
      },
    ]
  }

export default routerMarket;
